import { render, staticRenderFns } from "./ContactsListModal.vue?vue&type=template&id=90c0bd96&scoped=true&lang=pug&"
import script from "./ContactsListModal.vue?vue&type=script&lang=js&"
export * from "./ContactsListModal.vue?vue&type=script&lang=js&"
import style0 from "./ContactsListModal.vue?vue&type=style&index=0&id=90c0bd96&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90c0bd96",
  null
  
)

export default component.exports